import useWindowSize from './useWindowSize';
import { BREAKPOINT_MD_MIN } from '../constants';

export default function useIsMobile(): boolean {
    const { width } = useWindowSize();

    return width < BREAKPOINT_MD_MIN;
}
